const STORAGE_PREFIX = 'pos-recent-services'

/**
 * @param {number | string} branchId
 */
function storageKey(branchId) {
  return `${STORAGE_PREFIX}:${branchId}`
}

/**
 * @param {number | string} branchId
 * @returns {import('@/types/api').Service[]}
 */
export function loadRecentServices(branchId) {
  if (!branchId) return []

  try {
    const raw = localStorage.getItem(storageKey(branchId))
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.slice(0, 6) : []
  } catch {
    return []
  }
}

/**
 * @param {number | string} branchId
 * @param {import('@/types/api').Service} service
 */
export function rememberRecentService(branchId, service) {
  if (!branchId || !service?.id) return

  const current = loadRecentServices(branchId).filter((item) => item.id !== service.id)
  const next = [
    {
      id: service.id,
      name: service.name,
      duration: service.duration,
      price_ladies: service.price_ladies,
      price_gents: service.price_gents,
      category_id: service.category_id,
      is_active: service.is_active,
    },
    ...current,
  ].slice(0, 6)

  localStorage.setItem(storageKey(branchId), JSON.stringify(next))
}
